import * as Model from './vendorsModel';

export type Action = 
  | { type: 'VENDOR_SELECTED', vendor: Model.Vendor }
  | { type: 'VENDOR_IS_ACTIVE_CHANGED', value: boolean }
  | { type: 'VENDOR_NAME_CHANGED', value: string }
  | { type: 'VENDOR_ADDRESS1_CHANGED', value: string }
  | { type: 'VENDOR_ADDRESS2_CHANGED', value: string }
  | { type: 'VENDOR_CITY_CHANGED', value: string }
  | { type: 'VENDOR_POSTAL_CODE_CHANGED', value: string }
  | { type: 'VENDOR_COUNTRY_CHANGED', value: string }
  | { type: 'VENDOR_COUNTRY_SUB_DIVISION_CODE_CHANGED', value: string }
  | { type: 'VENDOR_PRIMARY_PHONE_CHANGED', value: string }
  | { type: 'VENDOR_MOBILE_PHONE_CHANGED', value: string }
  | { type: 'VENDOR_EMAIL_CHANGED', value: string }
  | { type: 'VENDOR_UPDATED_FROM_QBO', qboVendor: Model.QboVendor, updateInfo: boolean }
  | { type: 'VENDOR_QBO_LINK_RESET' };

export const reducer = (state: Model.Vendor, action: Action): Model.Vendor => {
  switch (action.type) {
    case 'VENDOR_SELECTED':
      return action.vendor;
    case 'VENDOR_IS_ACTIVE_CHANGED':
      return { ...state, isActive: action.value };
    case 'VENDOR_NAME_CHANGED':
      return { ...state, name: action.value };
    case 'VENDOR_ADDRESS1_CHANGED':
      return { ...state, address1: action.value };
    case 'VENDOR_ADDRESS2_CHANGED':
      return { ...state, address2: action.value };
    case 'VENDOR_CITY_CHANGED':
      return { ...state, city: action.value };
    case 'VENDOR_POSTAL_CODE_CHANGED':
      return { ...state, postalCode: action.value };
    case 'VENDOR_COUNTRY_CHANGED':
      return { ...state, country: action.value };
    case 'VENDOR_COUNTRY_SUB_DIVISION_CODE_CHANGED':
      return { ...state, countrySubDivisionCode: action.value };
    case 'VENDOR_PRIMARY_PHONE_CHANGED':
      return { ...state, primaryPhone: action.value };
    case 'VENDOR_MOBILE_PHONE_CHANGED':
      return { ...state, mobilePhone: action.value };
    case 'VENDOR_EMAIL_CHANGED':
      return { ...state, email: action.value };
    case 'VENDOR_UPDATED_FROM_QBO':
      return Model.updateFromQboVendor(state, action.qboVendor, action.updateInfo);
    case 'VENDOR_QBO_LINK_RESET':
      return { ...state, qboDisplayName: '', qboId: '' };
    default:
      return state;
  }
}